import { NotificationDataType } from "./NotificationSettings.types";

// list of notification type currently in use

export const timeRelatedNotiTypes: NotificationDataType[] = [
  NotificationDataType.BOOKING_START_REMINDER,
  NotificationDataType.BOOKING_CHECKIN_REMINDER,
  NotificationDataType.FLEET_BOOKING_START_REMINDER,
  NotificationDataType.FLEET_BOOKING_END_REMINDER,
  NotificationDataType.FLEET_ADMIN_BOOKING_START_REMINDER,
  NotificationDataType.FLEET_ADMIN_BOOKING_END_REMINDER
];
export const bookingNotiTypes: NotificationDataType[] = [
  NotificationDataType.BOOKING_START_REMINDER, // use
  // NotificationDataType.BOOKING_END_REMINDER, //
  NotificationDataType.BOOKING_INACTIVATION_ALERT,
  NotificationDataType.TEAM_BOOKING, // use
  // NotificationDataType.NOT_BOOKED_REMINDER //
  NotificationDataType.BOOKING_CHECKIN_REMINDER
];
export const approvalNotiTypes: NotificationDataType[] = [
  NotificationDataType.BOOKING_APPROVAL_ADMIN
  // NotificationDataType.BOOKING_APPROVAL_APPROVED, //
  // NotificationDataType.BOOKING_APPROVAL_REJECTED, //
  // NotificationDataType.BOOKING_APPROVAL_REQUEST //
];
export const supervisorNotiTypes: NotificationDataType[] = [
  // NotificationDataType.SUPERVISOR_EMPLOYEE_CREATE, //
  // NotificationDataType.SUPERVISOR_EMPLOYEE_DELETE, //
  // NotificationDataType.SUPERVISOR_EMPLOYEE_INACTIVATE //
];

export const serviceNotiTypes: NotificationDataType[] = [
  // NotificationDataType.SERVICE_QUANTITY_CHANGE //
  NotificationDataType.SERVICE_STATUS_INFO
];

export const connectionNotiTypes: NotificationDataType[] = [
  NotificationDataType.COLLEAGUE_INQUIRY //
];

/** Fleet notification types that are only shown when the user is a fleet admin */
export const fleetAdminOnlyNotiTypes: NotificationDataType[] = [
  NotificationDataType.FLEET_ADMIN_BOOKING_START_REMINDER,
  NotificationDataType.FLEET_ADMIN_BOOKING_END_REMINDER,
  NotificationDataType.FLEET_ADMIN_CHECKIN_REMINDER
];

export const fleetNotiTypes: NotificationDataType[] = [
  NotificationDataType.FLEET_BOOKING_START_REMINDER,
  NotificationDataType.FLEET_BOOKING_END_REMINDER,
  NotificationDataType.FLEET_BOOKING_CREATED_FOR_ME,
  NotificationDataType.FLEET_BOOKING_TIME_CHANGED,
  ...fleetAdminOnlyNotiTypes
];
